// extracted by mini-css-extract-plugin
module.exports = {"module":"SettingsPage_module__1EcMe","panels":"SettingsPage_panels__3GxHg"};